import { IOrderDetailByName } from "../models/IOrderDetail";
import { configWithUserToken } from "../../services/config";

export const getOrderDetailsByOrderName = (orderName: string) =>
  configWithUserToken.get<IOrderDetailByName>(
    `Order/GetOrderDetailsByOrderName/${orderName}`
  );
